import type { ProductLogoMediumProps } from '../types';

export function ProductLogoMediumCertifications({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M288 288C288 314.51 266.51 336 240 336C213.49 336 192 314.51 192 288C192 261.49 213.49 240 240 240C266.51 240 288 261.49 288 288Z"
        fill="white"
      />
      <path
        d="M156 408C156 381.49 177.49 360 204 360H276C302.51 360 324 381.49 324 408V424C324 428.418 320.418 432 316 432H164C159.582 432 156 428.418 156 424V408Z"
        fill="white"
      />
      <path
        d="M420 462C420 412.294 460.294 372 510 372C559.706 372 600 412.294 600 462C600 511.706 559.706 552 510 552C460.294 552 420 511.706 420 462Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M538.343 426.657C541.467 423.533 546.533 423.533 549.657 426.657L555.314 432.314C558.438 435.438 558.438 440.503 555.314 443.627L502.142 496.799C499.018 499.923 493.953 499.923 490.828 496.799L465.657 471.627C462.533 468.503 462.533 463.438 465.657 460.314L471.314 454.657C474.438 451.533 479.503 451.533 482.627 454.657L496.485 468.515L538.343 426.657Z"
        fill="#1A2142"
      />
      <path
        d="M360 276C360 269.373 365.373 264 372 264H468C474.627 264 480 269.373 480 276C480 282.627 474.627 288 468 288H372C365.373 288 360 282.627 360 276Z"
        fill="white"
      />
      <path
        d="M360 336C360 329.373 365.373 324 372 324H444C450.627 324 456 329.373 456 336C456 342.627 450.627 348 444 348H372C365.373 348 360 342.627 360 336Z"
        fill="white"
      />
      <path
        d="M360 396C360 389.373 365.373 384 372 384H396C402.627 384 408 389.373 408 396C408 402.627 402.627 408 396 408H372C365.373 408 360 402.627 360 396Z"
        fill="white"
      />
      <path d="M96 192C96 178.745 106.745 168 120 168V192H96Z" fill="white" />
      <path
        d="M516 168C529.255 168 540 178.745 540 192H516V168Z"
        fill="white"
      />
      <path d="M96 480H120V504C106.745 504 96 493.255 96 480Z" fill="white" />
      <path d="M120 168H516V192H120V168Z" fill="white" />
      <path
        d="M120 480H384C390.627 480 396 485.373 396 492C396 498.627 390.627 504 384 504H120V480Z"
        fill="white"
      />
      <path d="M96 192H120V480H96V192Z" fill="white" />
      <path
        d="M516 192H540V336C540 342.627 534.627 348 528 348C521.373 348 516 342.627 516 336V192Z"
        fill="white"
      />
    </svg>
  );
}
